module.exports = __webpack_public_path__ + "static/media/add_icon.de6407a5.svg";